import env from '../pages/MyAccount/utils/env';
import { assign, replace } from './navigation';

const redirectToLogin = () => {
  assign(`${env.loginUrl}${window.location.href}`);
};

const redirectToBaseSite = () => replace(process.env.REACT_APP_SITE_URL);

const redirectToPersonalSurvey = () => replace('/personal-survey');

export { redirectToLogin, redirectToBaseSite, redirectToPersonalSurvey };
